import ThreadComment from './ThreadComment';

export default ThreadComment;
